<template>
  <div class="duanwu-box">
    <!-- 活动标题 -->
    <div v-wechat-title="'端午粽子盲盒'"></div>
    <div class="header">
      <div class="user-phone-box">
        <div class="user-phone" v-if="userInfo.account">手机号{{userInfo.account | formatPhone}}</div>
        <div class="no-user" v-else>未登录</div>
      </div>
      <div class="btn-logout" v-if="userInfo.account" @click="userLogout"></div>
      <div class="btn-login" v-else @click="showLogin"></div>
    </div>
    <div class="lottery-box">
      <div class="btn-detail" @click="showDetail"></div>
      <div class="btn-price" @click="showReward"></div>
      <div class="btn-lottery" @click="startLottery">
        <div class="left-count">{{count}}</div>
      </div>
      <div class="btn-task" @click="showTask"></div>
      <div class="btn-qingyu" @click="goToQingYuCommon"></div>
      <div class="lottery-bottom"></div>
    </div>
    <div class="lottery-result-wrap popup_wrap" v-show="lotterying">
    <!-- <div class="lottery-result-wrap" v-show="lotterying"> -->
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div :class='["box",opened ? "opened" : ""]' v-show="lotterying">
          <div class="bg-shine"></div>
          <div class="cover"></div>
        </div>
      </transition>
      <div class="close-bg" @click="lotterying = false"></div>
    </div>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:loginCallback='loginCallback'
      :freeLogin="true"
      :gameName="gameName"
      game_id="68"
      :autoOpenOS="false"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      channelTips="">
    </Login>
    <!-- 抽奖结果-粽子票-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="lotteryResultShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box zongzi-box" v-show="lotteryResultShow">
          <div class="btn-qingyu" @click="goToQingYuCommon"></div>
          <div class="btn-box">
            <a href="javascript:;" @click="lotteryResultShow = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="lotteryResultShow = false"></div>
    </div>
    <!-- 抽奖结果-青钻-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="lotteryResult1Show">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div :class='["popup-wrap-box lottery-diamond-box",diamond === 1 ? "diamond666" : diamond === 2 ? "diamond100" : diamond === 3 ? "diamond10" : "diamond2"]' v-show="lotteryResult1Show">
          <div class="btn-qingyu" @click="goToQingYuCommon"></div>
          <div class="btn-box">
            <a href="javascript:;" @click="lotteryResult1Show = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="lotteryResult1Show = false"></div>
    </div>
    <!-- 抽奖结果-欧气爆棚-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="lotteryResult2Show">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div :class='["popup-wrap-box lottery-prize-box",prize === 1 ? "keyboard-box" : prize === 2 ? "mouse-box" : "charge-box"]' v-show="lotteryResult2Show">
          <div class="award-form">
            <p class="recipients">
              <input placeholder="请输入姓名" v-model="recipients" @focus="inputFocus()" @focusout="inputFocusOut" />
            </p>
            <p class="phone">
              <input placeholder="请输入手机号" v-model="phone" @focus="inputFocus()" @focusout="inputFocusOut" />
            </p>
            <p class="address">
              <input placeholder="请输入地址" v-model="address" @focus="inputFocus()" @focusout="inputFocusOut" />
            </p>
          </div>
          <div class="btn-box">
            <a href="javascript:;" @click="lotteryResult2Show = false">确定</a>
          </div>
          <div class="btn-confirm" @click="confirmClick"></div>
        </div>
      </transition>
    </div>
    <!-- 获得抽奖次数-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="getCountShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box" v-show="getCountShow">
          <div class="btn-box">
            <a href="javascript:;" @click="getCountShow = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="getCountShow = false"></div>
    </div>
    <!-- 抽奖次数不足-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="noCount">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box noCount-box" v-show="noCount">
          <div class="btn-box">
            <a href="javascript:;" @click="noCount = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="noCount = false"></div>
    </div>
    <!-- 抽奖须知-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="detail">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box detail-box" v-show="detail">
          <div class="btn-box">
            <a href="javascript:;" @click="detail = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="detail = false"></div>
    </div>
    <!-- 谢谢惠顾-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="noReward">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box noReward-box" v-show="noReward">
          <div class="btn-box">
            <a href="javascript:;" @click="noReward = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="noReward = false"></div>
    </div>
    <!-- 我的任务列表-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="modalTask">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box task-box" v-show="modalTask">
          <div :class='["task-game-item",task_list[5] ? "registered0" : "unregistered0"]'><div class="btn-go" @click="goToQingYu('login')"></div></div>
          <div :class='["task-game-item",task_list[4] ? "registered1" : "unregistered1"]'><div class="btn-go" @click="goToQingYu('register')"></div></div>
          <div :class='["task-game-item",task_list[6] ? "registered2" : "unregistered2"]'><div class="btn-go" @click="goLogin"></div></div>
          <div :class='["task-game-item",task_list[0] ? "registered3" : "unregistered3"]'></div>
          <div :class='["task-game-item",task_list[1] ? "registered4" : "unregistered4"]'></div>
          <div :class='["task-game-item",task_list[3] ? "registered5" : "unregistered5"]'></div>
          <div :class='["task-game-item",task_list[2] ? "registered6" : "unregistered6"]'></div>
          <div class="btn-box">
            <a href="javascript:;" @click="modalTask = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="modalTask = false"></div>
    </div>
    <!-- 我的奖品-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="myReward">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div :class='["popup-wrap-box",currentIndex ? "myReward-box" : "allReward-box"]' v-show="myReward">
          <ul class="all-record-list" v-show="currentIndex === 0">
            <li v-for="(item, index) in allReward_list" :key="index" :class="'record-item record-' + item"></li>
          </ul>
          <ul class="record-list" v-show="currentIndex === 1">
            <li v-for="(item, index) in record_list" :key="item.id || index" :class="'record-item record-' + item.real_id" >
              <div class="item-time">{{item.time}}</div>
              <div v-if="[1, 2, 3].includes(item.real_id)" class="btn-fillAddrress" @click="handleFillAddress(item.real_id)"></div>
            </li>
          </ul>
          <div class="btn-allReward" @click="currentIndex = 0"></div>
          <div class="btn-myReward" @click="currentIndex = 1"></div>
          <div class="btn-box">
            <a href="javascript:;" @click="myReward = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="myReward = false"></div>
    </div>
    <!-- 已填写地址-欧气爆棚-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="hasAddress">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div :class='["popup-wrap-box lottery-address-box",prize === 1 ? "keyboard-address" : prize === 2 ? "mouse-address" : "charge-address"]' v-show="hasAddress">
          <div class="btn-box">
            <a href="javascript:;" @click="hasAddress = false">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="hasAddress = false"></div>
    </div>
    <!-- 地址确认-弹窗 -->
    <div class="lottery-result-wrap popup_wrap" v-show="confirmAddress">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="popup-wrap-box confirm-address" v-show="confirmAddress">
          <div class="info-name">{{ recipients }}</div>
          <div class="info-phone">{{ phone }}</div>
          <div class="info-address">{{ address }}</div>
          <div class="confirm-btn" @click="submitAddress"></div>
          <div class="back-btn" @click="changeAwardInfoStatus"></div>
          <div class="btn-box">
            <a href="javascript:;" @click="confirmAddress = false">确定</a>
          </div>
        </div>
      </transition>
    </div>
    <!-- 阻止点击弹出-弹窗 -->
    <div @touchmove.prevent :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>

</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { Toast, Indicator } from "mint-ui";
import { getTimeStamp, buriedLogger } from '@/utils/utils'
import Login from '@/components/login'
import { onGetInitDataAPI, onSubmitAddress, getUrl, lottery, logout, getNum, addNum } from '../api'

export default {
  name: 'demo',
  components: {
    Login
  },
  data () {
    return {
      gameName: 'snail',
      downloadUrl: 'https://www.qcplay.com/',
      loginTypes: ['sms', 'password'],
      preventShow: false,
      lotteryResultShow: false, // 抽奖结果粽子票
      lotteryResult1Show: false, // 抽奖结果青钻
      lotteryResult2Show: false, // 抽奖结果欧气爆棚
      prize: 1, // 欧气爆棚结果1:键盘,2:鼠标,3:充电宝
      diamond: 1, // 青钻结果1:666,2:100,3:10,4:2
      getCountShow: false, // 获得抽奖次数
      noCount: false, // 抽奖次数不足
      detail: false, // 抽奖须知
      myReward: false, // 我的奖品
      noReward: false, // 谢谢惠顾
      modalTask: false, // 任务弹窗
      hasAddress: false, // 已填写地址弹窗
      confirmAddress: false, // 地址二次确认弹窗
      recipients: '',
      address: '',
      phone: '',
      focusTimer: null,
      count: 0, // 剩余抽奖次数
      miniWechatUrl: '',
      logger: null,
      task_list: [],
      record_list: [],
      isClick: false,
      hasName: '',
      lotterying: false,
      opened: false,
      currentIndex: 0, // 0:奖励一览，1：我的奖励列表
      allReward_list: [1, 2, 3, 4, 5]
    }
  },
  filters: {
    formatPhone: function (value) {
      if (!value) return ''
      return value.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
    }
  },
  created () {
    this.getUserNum()
  },
  mounted () {
    this.$nextTick(() => {
      this.isSetShare()
      // 埋点
      const bl = buriedLogger('qingyu', '端午');
      this.logger = bl
      getUrl().then((res) => {
        if(Number(res.code) === 200) {
          this.miniWechatUrl = res.data.uri
        }
      })
    })
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
    ])
  },
  methods: {
    //input聚焦
    inputFocus() {
      if (this.focusTimer) {
        clearTimeout(this.focusTimer)
      }
    },
    //input失焦
    inputFocusOut() {
      this.focusTimer = setTimeout(() => {
        window.scrollTo(0, 0)
      }, 10)
    },
    goLogin() {
      this.changeLoginPopup(true)
      this.modalTask = false
    },
    handleFillAddress(id) {
      this.myReward = false
      this.prize = id
      if(!this.hasName) {
        this.lotteryResult2Show = true
      } else {
        this.hasAddress = true
      }
    },
    // 点击登录
    loginCallback () {
      this.getUserNum()
    },
    showLogin() {
      this.changeLoginPopup(true)
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/qingyu/duanwu2023/enter${getTimeStamp()}`,
        title: '端午盲盒贩卖机',
        imgUrl: 'https://download4.qcplay.com/qcgame-admin/L4mSwQ6ReQzCCxQrWsI4HaNE56ofnDE75ADdeITP.png',
        desc: '参与抽奖活动赢粽子礼盒和更多限量好礼~'
      })
    },
    // 登录
    getUserNum() {
      getNum().then((res) => {
        if (Number(res.code) == 200) {
          this.init()
        }
      })
    },
    // 初始化
    init () {
      onGetInitDataAPI().then((res) => {
        if (Number(res.code) == 200) {
          const { userinfo, activity = {} } = res.data
          this.setUserInfo(userinfo)
          this.task_list = activity.task_list || []
          this.record_list = activity.record_list || []
          this.count = activity.times
          this.hasName = activity.name
        } else {
          Toast({
            message: res.message,
            duration: 1500,
            className: "toasts"
          })
        }
      })
    },
    confirmClick() {
      if (!this.recipients || !this.address || !this.phone) {
        Toast('请将信息填写完整')
        return false
      }
      // if (!/^1[3456789]\d{9}$/.test(this.phone)) {
      //   Toast('请输入正确的手机号码')
      //   return false
      // }
      this.confirmAddress = true
      this.lotteryResult2Show = false
    },
    changeAwardInfoStatus() {
      this.lotteryResult2Show = true
      this.confirmAddress = false
    },
    submitAddress() {
      onSubmitAddress({
        name: this.recipients,
        address: this.address,
        phone: this.phone,
      }).then((res) => {
        if (res.code === 200) {
          this.hasName = true
          this.confirmAddress = false
          this.clearAddressForm()
        }
        Toast({
          message: res.message,
          duration: 1500,
          className: "toasts"
        })
      })
    },
    userLogout() {
      logout().then((res) => {
        if(Number(res.code) === 200) {
          this.setUserInfo({})
          this.count = 0
          this.task_list = []
          this.record_list = []
          this.changeLoginPopup(true)
        } else {
          Toast({
            message: res.message,
            duration: 1500,
            className: "toasts"
          })
        }
      })
    },
    showDetail() {
      this.detail = true
    },
    showTask() {
      this.modalTask = true
    },
    goToQingYu(type) {
      const logName = type === 'login' ? '青宇小程序登录跳转' : '青宇小程序注册跳转'
      this.logger.sum(logName)
      if(type === 'login') {
        Indicator.open()
        addNum().then((res) => {
          Indicator.close()
          if(Number(res.code) === 200) {
            this.count ++
            this.task_list.splice(5, 1, 1)
            this.modalTask = false
            window.location.href = this.miniWechatUrl
          } else if(Number(res.code) === 403){
            console.log('已领取')
          } else {
            Toast({
              message: res.message,
              duration: 1500,
              className: "toasts"
            })
          }
        }).catch(() => {
          Indicator.close()
        })
      } else {
        // 链接需要后端动态生成, 一个链接只能一个用户使用
        window.location.href = this.miniWechatUrl
      }
    },
    goToQingYuCommon() {
      window.location.href = this.miniWechatUrl
    },
    startLottery() {
      if(!this.userInfo.account) {
        return this.changeLoginPopup(true)
      }
      if(this.count <= 0) {
        this.noCount = true
        return
      }
      if(this.isClick) {
        return false
      }
      this.isClick = true
      this.logger.sum('参与抽奖')
      this.lotterying = true
      this.opened = true
      this.preventShow = true
      this.count = this.count - 1
      lottery().then((res) => {
        this.isClick = false
        if(Number(res.code) === 200) {
          this.init()
          setTimeout(() => {
            this.opened = false
            this.lotterying = false
            setTimeout(() => {
              this.preventShow = false
            }, 1000)
            switch(res.data.res) {
              case 9:
                this.noReward = true
                break
              case 8:
                this.lotteryResult1Show = true
                this.diamond = 4
                break
              case 7:
                this.lotteryResult1Show = true
                this.diamond = 3
                break
              case 6:
                this.lotteryResult1Show = true
                this.diamond = 2
                break
              case 5:
                this.lotteryResult1Show = true
                this.diamond = 1
                break
              case 4:
                this.lotteryResultShow = true
                break
              case 3:
                this.lotteryResult2Show = true
                this.prize = 3
                break
              case 2:
                this.lotteryResult2Show = true
                this.prize = 2
                break
              case 1:
                this.lotteryResult2Show = true
                this.prize = 1
                break
            }
          }, 1000)
        } else {
          Toast({
            message: res.message,
            duration: 1500,
            className: "toasts"
          })
          this.isClick = false
          this.opened = false
          this.preventShow = false
          this.lotterying = false
        }
      }).catch(() => {
        this.isClick = false
        this.opened = false
        this.preventShow = false
        this.lotterying = false
        Toast({
          message: '请求出错啦,请刷新页面或联系客服',
          duration: 1500,
          className: "toasts"
        })
      })
    },
    clearAddressForm() {
      this.recipients = ''
      this.address = ''
      this.phone = ''
    },
    showReward() {
      if(!this.userInfo.account) {
        return this.changeLoginPopup(true)
      }
      this.myReward = true
    },
    ...mapMutations([
      'changeLoginPopup',
      'setUserInfo',
    ]),
    ...mapActions([
      'setShare'
    ])
  }
};
</script>

<style lang="less" scope>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/qingyu/duanwu2023/index/index.vue